// src/components/SearchForm.js
import React, { useState, useEffect } from 'react';
import './SearchForm.css';

export default function SearchForm({ onSearch, initialFilters = {} }) {
  const [genre, setGenre] = useState('');
  const [type, setType] = useState('');
  const [city, setCity] = useState('');

  useEffect(() => {
    if (initialFilters) {
      setGenre(initialFilters.genre || '');
      setType(initialFilters.type || '');
      setCity(initialFilters.city || '');
    }
  }, [initialFilters]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    onSearch({ genre, type, city });
  };

  return (
    <form className="search-form" onSubmit={handleSubmit}>
      <select value={genre} onChange={(e) => setGenre(e.target.value)}>
        <option value="">Tous les genres</option>
        <option value="Jazz">Jazz</option>
        <option value="Pop">Pop</option>
        <option value="Rock">Rock</option>
        <option value="Variété">Variété</option>
        <option value="Classique">Classique</option>
        <option value="Blues">Blues</option>
        <option value="Flamenco">Flamenco</option>
        <option value="Oriental">Oriental</option>
      </select>

      <select value={type} onChange={(e) => setType(e.target.value)}>
        <option value="">Tous les types</option>
        <option value="Chanteur">Chanteur</option>
        <option value="Guitariste">Guitariste</option>
        <option value="Batteur">Batteur</option>
        <option value="Percussionniste">Percussionniste</option>
        <option value="Pianiste">Pianiste</option>
        <option value="Violoniste">Violoniste</option>
        <option value="Danseur">Danseur</option>
        <option value="Oudiste">Oudiste</option>
        <option value="Bassiste">Bassiste</option>
        <option value="Groupe">Groupe</option>
        <option value="DJ">DJ</option>
      </select>

      <select value={city} onChange={(e) => setCity(e.target.value)}>
        <option value="">Toutes les villes</option>
        <option value="Marrakech">Marrakech</option>
        <option value="Rabat">Rabat</option>
        <option value="Casablanca">Casablanca</option>
        <option value="Tanger">Tanger</option>
      </select>

      <button type="submit">Rechercher</button>
    </form>
  );
}
